import React from 'react'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Avatar from '@material-ui/core/Avatar'
import { dateFormatMask } from '@plandi/common'
import clsx from 'clsx'

import { useChatStyles } from './chat.styles'

type ChatMessageProps = {
  id?: number
  text?: string
  createdAt?: string
  name?: string
  avatarUrl?: string | null
  position?: 'start' | 'end'
}

export const ChatMessage = (props: ChatMessageProps) => {
  const classes = useChatStyles()

  return (
    <div
      className={clsx(classes.message, {
        [classes.messageReverse]: props.position === 'end'
      })}
    >
      <Avatar src={props?.avatarUrl ?? ''} className={classes.avatar}>
        {props?.name?.slice(0, 1)}
      </Avatar>
      <Card className={classes.messageCard}>
        <CardContent className={classes.messageCardContent}>
          <Typography variant="body2" gutterBottom>
            {props.text}
          </Typography>
          <Typography
            align="right"
            variant="caption"
            component="div"
            color="textSecondary"
          >
            {props.createdAt &&
              dateFormatMask(props.createdAt, 'HH:mm, DD.MM.YYYY')}
          </Typography>
        </CardContent>
      </Card>
    </div>
  )
}
